// extracted by mini-css-extract-plugin
export default {"icon":"LanguageIcon_icon__9GIU9"};